import React from 'react';
import NewsFeed from '../components/NewsFeed';

const NewsPage: React.FC = () => {
  return (
    <div className="news-page-container">
      <h1>News & Regulatory Updates</h1>
      <p>Stay informed with the latest news and regulatory changes in finance, law, and tax.</p>
      <NewsFeed />
    </div>
  );
};

export default NewsPage;
